export type Department = {
  id: number
  title: string
}

export enum DepartmentRole {
  Contributor = 1,
  Admin = 2,
}

export type DepartmentUser = {
  userId: number
  departmentId: number
  role: DepartmentRole
}
